import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[d3TooltipHost]'
})
export class D3TooltipHostDirective {

  constructor(public viewContainerRef: ViewContainerRef) { }

}



// WEBPACK FOOTER //
// /Users/andyperlitch/repos/ngx-d3-tooltip/src/app/modules/d3-tooltip/d3-tooltip-host.directive.ts